import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InlineSubtemplateFormattingEditing from './inlinesubtemplateformattingediting';

export default class InlineSubtemplateFormatting extends Plugin {
  static get requires() {
    return [InlineSubtemplateFormattingEditing];
  }

  static get pluginName() {
    return 'InlineSubtemplateFormatting';
  }
}